import * as palette from "../../components/symbols/palette"

const createChatPrompt = ({
  promptData,
  promptLayers,
  includeProperties,
  includeDoco,
  includeIds = true,
}) => {
  const prompt = []

  const shortIds = {}

  let shortIdCount = 1

  const RELATIONSHIP_DESCRIPTORS = {
    [palette.TRIGGERING_RELATIONSHIP]: "triggers",
    [palette.ASSOCIATION_RELATIONSHIP]: "is associated with",
    [palette.COMPOSITION_RELATIONSHIP]: "composes",
    [palette.AGGREGATION_RELATIONSHIP]: "aggregates",
    [palette.ACCESS_RELATIONSHIP]: "accesses",
    [palette.REALIZATION_RELATIONSHIP]: "realizes",
    [palette.FLOW_RELATIONSHIP]: "flows to",
    [palette.ASSIGNMENT_RELATIONSHIP]: "assigns",
    [palette.SERVING_RELATIONSHIP]: "serves",
    [palette.INFLUENCE_RELATIONSHIP]: "influences",
  }

  // Return a short id for an element. Short IDs are used to simplify the representation of elements in the prompt,
  // making it easier to read and reference them. Short IDs start at 1, 2, 3, ..., and are generated only if a long ID
  // does not already have a corresponding short ID. This ensures that each element has a unique and consistent identifier
  // throughout the prompt.
  const getShortId = (longId) => {
    if (shortIds[longId]) {
      return shortIds[longId]
    }

    const shortId = `ID:${shortIdCount++}`
    shortIds[longId] = shortId
    return shortId
  }

  prompt.push(
    `The following information is for an Architecture view called '${promptData.view.name}'.`
  )

  const getLabel = (el, includeLabel = true) => {
    if (includeIds) {
      const label = includeLabel ? `(${palette.formatLabel(el.type)})` : ""
      return `[${getShortId(el.id)}] '${el.name}' ${label}`.trim()
    }
    return el.name
  }

  const { elements } = promptData

  const getLabelForElementRef = (elementRef, includeLabel) => {
    const el = elements.find(
      (el) => el.name === elementRef.name && el.type === elementRef.type
    )
    if (el) {
      return getLabel(el, includeLabel)
    }
    return `${elementRef.type} ${elementRef.name} - NOT FOUND`
  }

  elements.forEach((el) => {
    prompt.push(
      `**${getLabel(el)}**:${
        includeDoco && el.documentation.length > 0 ? ` ${el.documentation}` : ""
      }`
    )

    if (includeProperties && el.props.length > 0) {
      prompt.push(
        ` *Properties*: ${el.props.map(
          (prop) => ` ${prop.name}=${prop.value}`
        )}`
      )
    }

    const groupedConnections = el.connections.reduce((acc, curr) => {
      if (!acc[curr.type]) {
        acc[curr.type] = []
      }
      acc[curr.type].push(curr.target)
      return acc
    }, {})

    const relTypes = Object.keys(groupedConnections)

    relTypes.forEach((relType) => {
      const targetElements = groupedConnections[relType]
      prompt.push(`  **${RELATIONSHIP_DESCRIPTORS[relType]}**:`)
      for (const targetElement of targetElements) {
        prompt.push(`  - ${getLabelForElementRef(targetElement, false)}`)
      }
    })
  })

  return prompt
}

export { createChatPrompt }
